import localforage from 'localforage';
import React from 'react';

import { createContext, useEffect, useReducer } from 'react';

const INITIAL_STATE = {
    user: localStorage.getItem('user') || null,
    loading: false,
    authentication_token: ""
};

export const AuthContext = createContext(INITIAL_STATE);

const AuthReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN_START':
            return {
                user: null,
                loading: true,
            };
        case 'LOGIN_SUCCESS':
            return {
                user: action.payload,
                loading: false,
            };
        case 'LOGIN_FAILURE':
            return {
                user: null,
                loading: false,
            };
        case 'LOGOUT':
            return {
                user: null,
                loading: false,
            };
        default:
            return state;
    }
};

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

    useEffect(() => {
        localforage.setItem('user', JSON.stringify(state?.user));
    }, [state.user]);

    return (
        <AuthContext.Provider
            value={{
                user: state.user,
                loading: state.loading,
                dispatch
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
